'use client';
import React, { useEffect, useState } from 'react';
import { Button, Div } from '@pezeshk-book/ui-kit';
import getParseRoute from '@utils/helpers/parse-route';
import routes from '@routes';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import { ConsultsActions } from '@store/consults/consults-actions';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';
import getDictionary from '@dictionaries-client';

const DoctorItemButtons = ({ userServiceFee, hashUserId, slug }: { userServiceFee: Array<any>, hashUserId: string, slug: string }) => {
  const dispatch = useDispatch();
  const [hasConsult, setHasConsult] = useState(false);
  const [hasAppointment, setHasAppointment] = useState(false);
  const consultReducer = useSelector((state: RootState) => state.consults);
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { users } = getDictionary(lang);
  useEffect(() => {
    userServiceFee && userServiceFee.length > 0 && userServiceFee.map((item: any) => {
      if (item.type_id === 1) {
        setHasAppointment(true);
      }
      if (item.type_id === 2) {
        setHasConsult(true);
      }
    });
  }, [userServiceFee]);

  const handleConsultInitial = () => {
    if (hashUserId !== consultReducer.hashUserId) {
      dispatch(ConsultsActions.setInitialState());
    }
  };

  return (
    <Div className={'mt-4 mb-1 flex-row-reverse sm:flex-col gap-4'}>
      {process.env.CONSULT_SERVICE_ACTIVE === 'true' ? (
        <Button
          onClick={handleConsultInitial}
          disabled={!hasConsult}
          href={hasConsult ? getParseRoute({ pathname: routes['route.consults.dialogue-box'], query: { slug: slug }, locale: lang }) : '#'}
          className={'w-1/2 sm:w-52'}>
          {users.index.filter.services.consult}
        </Button>
      ) : null}
      {process.env.APPOINTMENT_SERVICE_ACTIVE === 'true' ? (
        <Button
          disabled={!hasAppointment || true}
          href={hasAppointment ? getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug, id: '1' }, locale: lang }) : '#'}
          className={'w-1/2 sm:w-52'}>
          {users.index.filter.services.appointment}
        </Button>
      ) : null}
    </Div>
  );
};

export default DoctorItemButtons;
